import * as XLSX from "xlsx";

const SAMPLE_ROW_PREFIX = "[sample]";

const normalizeCell = (value) => {
  if (value === undefined || value === null) return "";
  return String(value).trim();
};

const isSampleRow = (row = []) => {
  const name = normalizeCell(row[0]);
  return name.toLowerCase().startsWith(SAMPLE_ROW_PREFIX);
};

export const stripSampleRowsFromXlsx = async (file, entityLabel = "row") => {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array" });
  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];
  const rows = XLSX.utils.sheet_to_json(worksheet, {
    header: 1,
    defval: "",
    raw: false,
  });

  if (!rows.length) {
    return file;
  }

  const [headerRow, ...dataRows] = rows;
  const emptyRowNumbers = [];
  const uploadRows = [];

  dataRows.forEach((row, index) => {
    const rowNumber = index + 2;
    const hasValues = row.some((cell) => normalizeCell(cell) !== "");
    if (!hasValues) {
      emptyRowNumbers.push(rowNumber);
      return;
    }
    if (isSampleRow(row)) {
      return;
    }
    uploadRows.push(row);
  });

  if (emptyRowNumbers.length) {
    throw new Error("Empty rows found.");
  }

  if (!uploadRows.length) {
    throw new Error(
      `No ${entityLabel} rows found to upload. Add your data from row 3 onward and keep the sample row as reference only.`
    );
  }

  const cleanedSheet = XLSX.utils.aoa_to_sheet([headerRow, ...uploadRows]);
  const cleanedWorkbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(cleanedWorkbook, cleanedSheet, sheetName || "Sheet1");

  const output = XLSX.write(cleanedWorkbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([output], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  return new File([blob], file.name, { type: blob.type });
};

export const prepareServiceBulkUploadFile = (file) =>
  stripSampleRowsFromXlsx(file, "service");

export const prepareDietBulkUploadFile = (file) =>
  stripSampleRowsFromXlsx(file, "diet item");

export const prepareTherapyBulkUploadFile = (file) =>
  stripSampleRowsFromXlsx(file, "therapy");

export const prepareInvestigationBulkUploadFile = (file) =>
  stripSampleRowsFromXlsx(file, "investigation");
